module.exports = __webpack_public_path__ + "img/welding-1.5fe6790c.jpg";